import React, { useState, useRef, useImperativeHandle, forwardRef } from "react";
import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { Messages } from "primereact/messages";
import { PrimaryButton, SecondaryButton } from "../../../components/Buttons";
import { ClipBoardContent, pasteFromClipboard } from "../ClipBoard";

const ClipBoardDialog = forwardRef(({ onConfirm: onConfirmProp }, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [selected, setSelected] = useState([]);
  const onConfirmRef = useRef(onConfirmProp);
  const messagesRef = useRef(null);

  useImperativeHandle(ref, () => ({
    show: (visible, onConfirm) => {
      onConfirmRef.current = onConfirm;
      setIsVisible(visible);
      setSelected([]);
    }
  }));

  const onHide = () => setIsVisible(false);

  const onClick = (isYes) => {
    if (!isYes) {
      return onHide();
    }
    if (!selected || selected.length === 0) {
      return messagesRef.current.replace({
        severity: "error",
        summary: "Sie müssen mindestins einen Inhalt auswählen",
        life: 1000 * 10,
        closable: true
      });
    }
    messagesRef.current.clear();
    onHide();
    if (onConfirmRef.current) {
      onConfirmRef.current(pasteFromClipboard(selected));
    }
  };

  const footer = (
    <div className="alg-right">
      <PrimaryButton className="margin-lft" onClick={() => onClick(true)}>{`Einfügen`}</PrimaryButton>
      <SecondaryButton className="margin-lft" onClick={() => onClick(false)}>{`Abbrechen`}</SecondaryButton>
    </div>
  );

  return (
    <Dialog
      header={"Zwischenablage"}
      footer={footer}
      iconsTemplate={null}
      visible={isVisible}
      style={{width: "400px"}}
      modal={true}
      onHide={onHide}
    >
      <Messages ref={messagesRef} />
      <ClipBoardContent
        selected={selected}
        onSelect={setSelected}
      />
    </Dialog>
  );
});

ClipBoardDialog.propTypes = {
  title: PropTypes.string,
  onConfirm: PropTypes.func
};

export default ClipBoardDialog;
